import React from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { IconBackArrow } from 'src/viewLayer/components/DesignSystem'
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink'
import { onBackButtonClicked } from 'src/viewLayer/helpers/safeNativeReporter'
import { useEmailPagePath } from 'src/viewLayer/navigation'

import { BackButtonContainer } from './index.styled'

export default (properties) => {
  const { devicePath } = useAppConfigContext()

  const isNativeMobileAndEmailView = devicePath === 'login-mobile' && properties.path === 'email'
  const isNativeMobileAndPasswordView =
    devicePath === 'login-mobile' && properties.path === 'password'
  const isNativeMobileAndBusinessView =
    devicePath === 'login-mobile' && properties.path === 'business'

  // Back button in email and business view native
  if (isNativeMobileAndEmailView || isNativeMobileAndBusinessView) {
    const trackingId = isNativeMobileAndEmailView
      ? 'email_back_button_webview'
      : 'b2b_sso_back_button_webview'
    return (
      <BackButtonContainer>
        <TrackableLink
          {...properties}
          aria-label="email_login.btn.back"
          data-testid="back-button-webview"
          href="#"
          icon={<IconBackArrow />}
          onClick={onBackButtonClicked}
          trackingId={trackingId}
        />
      </BackButtonContainer>
    )
  }

  // Back button in password view native
  if (isNativeMobileAndPasswordView) {
    return (
      <BackButtonContainer>
        <TrackableLink
          {...properties}
          aria-label="passsword.btn.back"
          className="BackButton"
          data-testid="back-button-default"
          href={useEmailPagePath()}
          icon={<IconBackArrow />}
        />
      </BackButtonContainer>
    )
  }

  return null
}
